<template>
  <div class='fucaiInfo'>
    <div class="kv">
      <img src="@/assets/family/fucai/info/kv.png" alt="">
    </div>
    <div class="info">
      <div class="info-name">{{colorData.color_name}}</div>
      <div class="line-s"></div>
      <div class="line-l"></div>
      <div class="desc">{{colorData.color_desc}}</div>
    </div>
    <div v-html="html" class="content"></div>
  </div>
</template>

<script>
import { getColors } from '@/api/product.js'
import axios from '@/util/request'
export default {
  name: 'FuCaiInfo',
  components:{
  },
  data() {
    return {
      id: '',
      colorData: {},
      html: ''
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.id = this.$route.query.id
    this.init()
  },
  mounted() {
      
  },
  methods: {
    init() {
      getColors({
        id: this.id
      }).then(res => {
        this.colorData = res.data
        if (res.result === 1) {
          this.info = res.data
          this.mp_title_pic = JSON.parse(this.info.mp_title_pic)
          this.getHtml()
        }
      })
      setTimeout(() => {
        document.querySelectorAll('oembed[url]').forEach(element => {
          const videoLable = document.createElement('video')
          videoLable.setAttribute('src', element.getAttribute('url'))
          videoLable.setAttribute('controls', 'controls')
          videoLable.setAttribute('playsinline', '')
          videoLable.setAttribute('style', ' width: 100%;height: 100%; ')
          element.appendChild(videoLable)
        })
      }, 500)
    },
    getHtml() {
      axios.get(this.info.mp_content)
        .then(res => {
          this.html = res
          /* const reg = new RegExp('https:///', 'g')
          this.html = res.replace(reg, '/') */
          // this.html = res.substring(res.indexOf('/style>') + 7, res.length + 1)
        })
    }
  }
}
</script>
<style lang='less' scoped>
.fucaiInfo {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .kv {
    width: 100%;
    max-width: 1920px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .info{
    position: absolute;
    width: 1440px;
    height: 248px;
    margin-top: -122px;
    left: 50%;
    transform: translateX(-50%);
    background: #FFFFFF;
    box-shadow: 0px 3px 18px 0px rgba(204,204,204,0.57);
    border-radius: 8px;
    padding-left: 67px;
    .info-name{
      padding-right: 67px;
      font-size: 36px;
      font-weight: 400;
      color: #333333;
      margin-top: 40px;
      text-overflow :ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
      white-space :nowrap; /*让文字不换行*/
      overflow : hidden;
      font-family: FZLanTingHeiS-DB-GB;
      text-align: left;
    }
    .line-s{
      width: 100px;
      height: 2px;
      background: #009245;
      margin-top: 30px;
    }
    .line-l{
      width: 100%;
      height: 1px;
      background: #E3E3E3;
    }
    .desc{
      min-height: 15px;
      font-size: 32px;
      font-weight: 400;
      color: #333333;
      margin-top: 30px;
      padding-right: 19px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      word-break: break-all;
      font-family: FZLanTingHeiS-DB-GB;
      text-align: left;
    }
  }
  /deep/ .content{
    width: 1440px;
    margin: 150px auto 0;
    p {
      font-size: 14px;
    }
    img {
      width: 100%;
      max-width: 100%;
    }
    .text-huge{
      font-size: 25px;
    }
    .text-big{
      font-size: 19px;
    }
    .text-small{
      font-size: 12px;
    }
    .text-tiny{
      font-size: 10px;
    }
  }
}
</style>